import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionA');
    return (
        <div className={styles.TheComp} id="r3-sectionA">
            <EfSection
                position="hoverL"
                hasAnimation={false}
                theme="white"
                pc="https://websiteoss.ecoflow.com/upload/image/1724569529324/sectionA.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724569639136/sectionA_h5.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
            />
        </div>
    );
}
